module.exports = __webpack_public_path__ + "img/Features_dev_2.cd6ba780.png";